export const career = [
    {
        id: 1,
        year: "Dec 2023 – Present",
        location: 'Bengaluru, Karnataka',
        company: 'Infogain India Private Limited',
        post: 'Technical Lead',
        link: "https://www.infogain.com/",
        desc:
            "Working with Infogain Team with multiple clients getting their requirement and transforming into reality and many more fun yet to come.",
    },
    {
        id: 2,
        year: "Aug 2020 – July 2023",
        location: 'Mumbai, Maharashtra',
        company: 'One97 Communications Limited(Paytm)',
        post: 'Senior Software Engineer',
        link: "http://paytminsurance.co.in/",
        desc:
            "Handling all use cases from frontend Core team for Common Components that used by across Paytm. Build our own UI Library for styling component and support core development for the Entire PAYTM Application..",
    },
    {
        id: 3,
        year: "Feb 2018 - March 2020",
        location: 'Mumbai, Maharashtra',
        company: 'Coverfox Insurance Broking Pvt. Ltd',
        post: 'Lead Frontend/UI Developer',
        link: "https://www.coverfox.com",
        desc:
            "Working on Product Development, Optimising Pages, SEO Friendly Pages, Integrating Animations which is matching with page flow, Maintaining &amp; Building Tools etc.",
    },
    {
        id: 4,
        year: "Sept 2016 - Jan 2018",
        location: 'Mumbai, Maharashtra',
        company: 'HDFC Developers Ltd.',
        post: 'Sr. Frontend Developer',
        link: "https://www.hdfcred.com",
        desc:
            "Frontend Responsibilities all included HTML,CSS/Animation/Effects, JS, Web Building Tools, Web Optmisations.",
    },
    {
        id: 5,
        year: "June 2015 - June 2016",
        location: 'New Delhi',
        company: 'Railsmancer Technologies',
        post: 'Frontend Developer',
        link: "https://www.railmancers.com",
        desc:
            "Desigining &amp; Developing Webpages and PSDs, clients conversation and taking care about all thier requirements and changes.",
    },
    {
        id: 6,
        year: "June 2013 - June 2015",
        location: 'New Delhi',
        company: 'Web Experts Infotech Llp.',
        post: 'Web Designer and Developer',
        link: "https://www.weinfotech.com",
        desc:
            "Worked on all Company Portals from various fields (E-Commerce, Property Portal, B2B Portal, B2C Portal, Local Search Engine, Templating, Email Designing and Email Marketing, Website Promotions(SEO), Mobile Advertising).",
    },
    {
        id: 7,
        year: "Feb 2012 - July 2012",
        location: 'Gujarat',
        company: 'Kochar Tech.',
        post: 'Sr. Technical Support Officer(IT Dept)',
        link: "https://www.kochartech.com",
        desc:
            "I was Handling there all the Responsibilities of IT(Hardware & Networking) Internet Protocol Linking of Live Applications at Baroda Division in Gujarat.",
    },
    {
        id: 8,
        year: "June 2011 - Feb 2012",
        location: 'New Delhi',
        company: 'HCL Infosystems Ltd.',
        post: 'Summer Internship',
        link: "https://www.weinfotech.com",
        desc:
            "Radio Frequency Project TETRA(Terrestrial Trunk Radio ) Handling Network Testing, Edit Connective Group and Change Different Talkative Groups & Linking Group & Programming, Signal Strength Verify..",
    },
    {
        id: 9,
        year: "June 2007 - June 2011",
        location: 'Punjab, Amritsar',
        company: 'B-Tech (Punjab Technical University)',
        post: 'Computer Science & Engineering',
        link: "https://www.ptu.ac.in",
        desc:
            "I have completed B-Tech",
    },
    {
        id: 10,
        year: "June 2005 - June 2007",
        location: 'Amethi - Uttar Pradesh',
        company: 'Shri Ranvir Inter College',
        post: 'Physics, Chemistry, Maths',
        link: "#",
        desc:
            "Done schooling from UPTU - Allahabad, Uttar Pradesh",
    },
]